import { SVGProps } from "react";

const Profile2User = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="58"
      height="58"
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.1362 26.2688C21.8945 26.2447 21.6045 26.2447 21.3387 26.2688C15.587 26.0755 11.0195 21.363 11.0195 15.563C11.0195 9.64217 15.8045 4.83301 21.7495 4.83301C27.6704 4.83301 32.4795 9.64217 32.4795 15.563C32.4554 21.363 27.8879 26.0755 22.1362 26.2688Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6579 9.66699C44.3462 9.66699 48.1162 13.4612 48.1162 18.1253C48.1162 22.6928 44.4913 26.4145 39.9721 26.5837C39.7788 26.5595 39.5613 26.5595 39.3438 26.5837"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0542 35.187C4.20589 39.102 4.20589 45.482 10.0542 49.3728C16.7001 53.8195 27.5992 53.8195 34.2451 49.3728C40.0934 45.4578 40.0934 39.0778 34.2451 35.187C27.6234 30.7645 16.7242 30.7645 10.0542 35.187Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.3223 48.333C46.0623 47.9705 47.7056 47.2697 49.0589 46.2305C52.8289 43.403 52.8289 38.7388 49.0589 35.9113C47.7298 34.8963 46.1106 34.2197 44.3948 33.833"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Profile2User;
